export const EXPIRED_MAGIC_LINK = "expired-magic-link" as const

export class ExpiredMagicLinkError extends Error {
  constructor() {
    super(
      "Your login link has expired. You can receive a new one by entering your email address again."
    )
  }
}
